(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecrin-atelier"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ecrin-atelier'))customElements.define('ecrin-atelier',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('[data-card]')];if(!this.cards.length)return;this.index=0;this.classList.add('is-ready');this.querySelector('[data-prev]').onclick=()=>this.show(this.index-1);this.querySelector('[data-next]').onclick=()=>this.show(this.index+1);this.cards.forEach((card,i)=>{card.querySelector('.ea-photo').onclick=()=>this.show(i);const select=card.querySelector('select');select.onchange=()=>{const option=select.selectedOptions[0];card.querySelector('.ea-price').textContent=option.dataset.price;const img=card.querySelector('img');img.removeAttribute('srcset');img.src=option.dataset.image;img.alt=option.dataset.alt;const link=card.querySelector('.ea-link');link.href=link.dataset.base+'?variant='+option.value;};});let start=null;const stage=this.querySelector('.ea-stage');stage.addEventListener('touchstart',e=>{if(e.target.closest('select,a'))return;start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));},{passive:true});this.addEventListener('keydown',e=>{if(e.target.closest('select'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});this.show(0);}
 show(index){const n=this.cards.length;this.index=(index+n)%n;this.cards.forEach((card,i)=>{let offset=(i-this.index+n)%n;if(offset>n/2)offset-=n;card.style.setProperty('--offset',offset);card.classList.toggle('is-active',i===this.index);const active=i===this.index;card.querySelector('.ea-info').inert=!active;});this.querySelector('.ea-count').textContent=String(this.index+1).padStart(2,'0')+' / '+String(n).padStart(2,'0');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecrin-fleur"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ecrin-fleur')){
customElements.define('ecrin-fleur',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;this.index=1;this.paused=true;
this.slides=Array.from(this.querySelectorAll('.ef-slide'));this.buttons=Array.from(this.querySelectorAll('[data-slide]'));
this.pauseButton=this.querySelector('[data-pause]');this.pauseButton.setAttribute('aria-pressed','true');
this.buttons.forEach((b,i)=>b.addEventListener('click',()=>{this.show(i);this.paused=true;this.pauseButton.setAttribute('aria-pressed','true');this.start()}));
this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.start()});
this.addEventListener('mouseenter',()=>clearInterval(this.timer));this.addEventListener('mouseleave',()=>this.start());
this.addEventListener('focusin',()=>clearInterval(this.timer));this.addEventListener('focusout',()=>this.start());
this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.start()
}
show(i){this.index=i;this.slides.forEach((s,n)=>{s.classList.toggle('is-active',i===n);s.setAttribute('aria-hidden',String(i!==n))});this.buttons.forEach((b,n)=>b.setAttribute('aria-pressed',String(i===n)))}
start(){clearInterval(this.timer);if(this.paused||this.motion.matches)return;this.timer=setInterval(()=>{if(!document.hidden)this.show((this.index+1)%this.slides.length)},5500)}
disconnectedCallback(){clearInterval(this.timer);this.initialized=false}
})
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
